import React from 'react';
import styled from 'styled-components';
import {Container} from '../styles/Grids';
import Img from '../components/Img';
import {breakPoint} from '../styles/var';


import img_title from '../assets/img/pc05-1.png';
import img_main from '../assets/img/pc05-2.png';
import img_btn_more from '../assets/img/pc05-3.png';
import OuterLink from '../components/OuterLink';
import img_4 from '../assets/img/4.png';
import img_5 from '../assets/img/5.png';


const ContentStyles = styled.div`
  --bg: var(--secondary);
  position: relative;
  background-color: var(--bg);

  &::before {
    content: "";
    display: block;
    width: 100%;
    height: 20rem;
    background-image: linear-gradient(-6deg, var(--bg) 50%, var(--other) 0%);
    margin-bottom: -4rem;
  }

  .container {
    padding: 4rem;

    > .desc {
      position: relative;
      width: 80%;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 2rem;

      > p {
        position: absolute;
        top: 29%;
        right: 10%;
        width: 32%;
      }
    }
  }

  .fixed-img {
    position: absolute;
  }

  .img-4 {
    top: 0;
    left: 10%;
    width: 160px;
  }

  .img-5 {
    bottom: 10%;
    left: 0;
    width: 144px;
  }

  @media (min-width: ${breakPoint.min}) {
    .container {
      padding-top: 8rem;
    }
  }
  @media (max-width: ${breakPoint.smMax}) {
    &::before {
      margin-top: -8rem;
      margin-bottom: -8rem;
    }

    .container {
      padding: 3rem 2rem;

      > .desc {
        width: 100%;
        margin-bottom: 2rem;

        > p {
          top: 14%;
          right: 0;
          width: 50%;
        }
      }
    }

    .img-4 {
      top: 13%;
      width: 50px;
    }

    .img-5 {
      width: 35px;
    }
  }
`;
const WrapStyles = styled.div`
  position: relative;

  > .title {
    position: absolute;
    top: 6%;
    left: 65%;
  }

  > .btn {
    position: absolute;
    top: 32%;
    left: 65%;
    width: 20%;

    > picture {
      text-align: left;
    }
  }

  @media (min-width: ${breakPoint.min}) {
    > .title {
      font-size: 4rem;
    }
  }
  @media (max-width: ${breakPoint.smMax}) {
    > .title {
      font-size: 1.3rem;
    }
    > .btn {
      position: absolute;
      width: 30%;
    }
  }
`;

const Section4 = (props) => {
    return (
        <ContentStyles {...props}>
            <Img src={img_4} wrapProps={{className: 'fixed-img img-4'}}/>
            <Img src={img_5} wrapProps={{className: 'fixed-img img-5'}}/>
            <Container className="container">
                <div className="desc">
                    <Img src={img_title}/>
                    <p>行走穿搭教科書．讓專家教你風格必備搭配指南</p>
                </div>
                <WrapStyles>
                    <Img src={img_main}/>
                    <h3 className={"title"}>懷孕也能穿出時尚品味！知名KOL萱妮孕期初、中、後3階段穿搭技巧大公開</h3>
                    <OuterLink href={'https://www.mombaby.com.tw/articles/9921699'} className={'btn'}>
                        <Img src={img_btn_more}/>
                    </OuterLink>

                </WrapStyles>
            </Container>
        </ContentStyles>
    )
};

export default Section4;
